import moment from "moment/moment";

export const getAutopayFrequencyDate = (selectedPolicy, billingType) => {
  if (selectedPolicy?.billingMode?.toLowerCase() === billingType?.toLowerCase())
    return moment(selectedPolicy?.paidThroughDate).format("MM/DD/YYYY");
  switch (billingType?.toLowerCase()) {
    case "monthly": {
      return moment(selectedPolicy?.paidThroughDate)
        .add(1, "days")
        .add(1, "months")
        .format("MM/DD/YYYY");
    }
    case "quarterly": {
      return moment(selectedPolicy?.paidThroughDate)
        .add(1, "days")
        .add(3, "months")
        .format("MM/DD/YYYY");
    }
    case "semi-annual": {
      return moment(selectedPolicy?.paidThroughDate)
        .add(1, "days")
        .add(6, "months")
        .format("MM/DD/YYYY");
    }
    case "annual": {
      return moment(selectedPolicy?.paidThroughDate)
        .add(1, "days")
        .add(12, "months")
        .format("MM/DD/YYYY");
    }
    default:
      return "";
  }
};
